var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ob1-message-alerte", {
    attrs: {
      title: _vm.title,
      "link-href": _vm.linkHref,
      "link-label": _vm.linkLabel,
      type: "info",
      "with-arrow-link": true,
      "is-simple-alerte": false,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }